import { MoreHorizontal } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";
import { Link, useLocation } from "react-router";
import { activeNavKey, mobileTabs } from "./navItems";
import { MoreSheet } from "./MoreSheet";
import { MobileCreateButton } from "./MobileCreateButton";
import { DuplicatesDot } from "../dataQuality/DuplicatesCount"; // GAVION import duplicates

const TAB =
  "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-medium";

export const MobileTabBar = () => {
  const translate = useTranslate();
  const { pathname } = useLocation();
  const active = activeNavKey(pathname);
  const [moreOpen, setMoreOpen] = useState(false);
  return (
    <>
      <nav
        aria-label={translate("gavion.nav.tabs")}
        className="fixed inset-x-0 bottom-0 z-30 flex border-t border-sidebar-accent bg-sidebar pb-[env(safe-area-inset-bottom)] text-sidebar-foreground"
      >
        {mobileTabs().map((item) => (
          <Link
            key={item.key}
            to={item.to}
            aria-current={active === item.key ? "page" : undefined}
            className={`${TAB} ${active === item.key || item.accent ? "text-sidebar-primary" : ""}`}
          >
            <item.icon className="size-5" aria-hidden="true" />
            {translate(item.mobileLabelKey ?? item.labelKey)}
          </Link>
        ))}
        <MobileCreateButton />
        <button type="button" className={TAB} onClick={() => setMoreOpen(true)}>
          <span className="relative">
            <MoreHorizontal className="size-5" aria-hidden="true" />
            <DuplicatesDot className="-right-1 -top-0.5" />
          </span>
          {translate("gavion.nav.more")}
        </button>
      </nav>
      <MoreSheet open={moreOpen} onOpenChange={setMoreOpen} />
    </>
  );
};
